import React, { FunctionComponent, useEffect, useCallback, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import _get from 'lodash/get';

import Header from '../../../components/Header';
import SubHeader from '../../../components/Fastag/Subheader/Details';
import Overview from '../../../components/Fastag/Detail/Overview';
import Transactions from '../../../components/Fastag/Detail/Transactions';
import { getVehicleParams } from '../../../components/Fastag/Listing/actions';
import { resetDetails, fetchTransactions, fetchTxnOverview } from '../../../components/Fastag/Detail/actions';
import { downloadTransactions } from '../../../components/Fastag/download';
import UrlConfig from '../../../utils/urlHelper';
import { ListingWrapper } from '../../../components/_globalStyled';
import { sendEvent2 } from '../../../utils/tracking';

interface MatchObj {
  params: {
    vehicleNum: string;
  };
}

interface Url {
  downloadTransactions: Function;
}

const urlHelper: Url = UrlConfig;

const Detail: FunctionComponent<{ match: MatchObj }> = ({ match }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [params, setParams] = useState({ pageNo: 0, transactionType: '', vehicleId: '', fromTime: '', toTime: '' });

  const vNum = _get(history, 'location.state.vehicleNumber', '');
  const [vehicleNumber, setVehicleNumber] = useState(vNum);

  const dispatchToStore = useCallback(
    (payload) => {
      dispatch(getVehicleParams(payload));
    },
    [dispatch],
  );

  const dispatchToStoreReset = useCallback(() => dispatch(resetDetails()), [dispatch]);

  const dispatchToStoreFetchTransactions = useCallback(
    (params: any) => dispatch(fetchTransactions(params)),
    [dispatch],
  );

  const dispatchToStoreFetchTxnOverview = useCallback((payload) => dispatch(fetchTxnOverview(payload)), [dispatch]);

  const downloadVehicleTransactions = (format: string) => {
    downloadTransactions(
      {
        ...(params.transactionType ? { txnType: params.transactionType } : {}),
        reportFormat: format,
        vehicleId: params.vehicleId,
        fromTime: params.fromTime,
        toTime: params.toTime,
      },
      urlHelper.downloadTransactions,
    );
  };

  const updateParams = (param: any) => {
    const paramObj = { ...params, ...param };
    setParams(paramObj);
  };

  useEffect(() => {
    if (params.vehicleId) {
      dispatchToStoreFetchTransactions({ ...params, vehicleNumber });
      dispatchToStoreFetchTxnOverview({
        id: params.vehicleId,
        fromTime: params.fromTime,
        toTime: params.toTime,
        txnType: params.transactionType,
      });
    }
    // TODO: handle dependencies vehicleNumber
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, dispatchToStoreFetchTransactions, dispatchToStoreFetchTxnOverview]);

  useEffect(() => {
    if (vehicleNumber) {
      dispatchToStore({ searchText: vehicleNumber, details: true });
    }
    return () => {
      dispatchToStoreReset();
    };
    // TODO: handle dependencies vehicleNumber
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatchToStore, dispatchToStoreReset]);
  useEffect(() => {
    sendEvent2(
      'screen_view',
      {
        event_action: 'view',
        screen_name: 'ft_vehicle_txn_details',
        target_product: 'fastag',
        event_platform: 'web',
      },
      true,
    );
  }, []);

  return (
    <div>
      <Header title="Fastag" link="/portal/fastag" history={history}>
        <SubHeader />
      </Header>
      <div>
        <Overview
          dispatchToStoreGetVehicle={(params: any) => {
            setVehicleNumber(params.searchText);
            dispatchToStore(params);
          }}
          updateParams={updateParams}
          dispatchToStoreReset={dispatchToStoreReset}
          vehicleNumber={vehicleNumber}
        />
      </div>
      <ListingWrapper>
        <div className="container mt5">
          <Transactions
            downloadVehicleTransactions={downloadVehicleTransactions}
            updateParams={updateParams}
            dispatchToStoreFetchTxnOverview={dispatchToStoreFetchTxnOverview}
          />
        </div>
      </ListingWrapper>
    </div>
  );
};

export default Detail;
